import React from 'react'
import styled from 'styled-components'
import { assignPrefix } from '../../../constants'

export interface ImageProps extends React.ComponentPropsWithoutRef<'img'> {
  caption?: string;
}

export default (props: ImageProps) => {
  return (
  <Wrapper>
    <Image {...props} src={assignPrefix(props.src || '')}/>
    {props.caption && <Title>{props.caption}</Title>}
  </Wrapper>
)}

// Styles
const Wrapper = styled.span`
  display: block;
  margin: 24px auto;
  .float-right {
    float: right;

    @media (max-width: 641px){
      display: none;
    }
  }
`

const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`

const Title = styled.span`
  display: block;
  color: ${p => p.theme.primaryLight2};
  font-style: italic;
  font-size: 18px;
  text-align: center;
  margin-top: 16px;
`
